export const PAGE_TYPES = ["personal", "business", "developers"];

export const getPageType = (pathname: string): string => {
  for (let i = 0; i < PAGE_TYPES.length; i++) {
    if (pathname.startsWith(`/${PAGE_TYPES[i]}`)) {
      return PAGE_TYPES[i];
    }
  }
  // Default to personal
  return PAGE_TYPES[0];
};
